import { SearchPageState } from './types'

const initialState: SearchPageState = {}

function reducer(state: SearchPageState = initialState, _action: unknown) {
  return state
}

export default reducer
